import { TenantFeatureModel } from '@utmost.co/enterprise-models';
import { MultiEngagementSettings } from './MultiEngagement.types.js';

export const mergeMultiEngagementSettings = (
  settings: MultiEngagementSettings,
  engagement: TenantFeatureModel
): TenantFeatureModel => ({
  ...engagement,
  orderedFeatures: engagement.orderedFeatures.map((feature) => {
    if (feature.name === 'max-active-employee-engagements') {
      return {
        ...feature,
        enabled: settings.maxActiveEmployeeEngagements,
        config: {
          ...feature.config,
          'max-active-employee-engagements-number': settings.maxActiveEmployeeEngagementsNumber.toString()
        }
      };
    }

    if (feature.name === 'max-active-non-employee-engagements') {
      return {
        ...feature,
        enabled: settings.maxActiveNonEmployeeEngagements,
        config: {
          ...feature.config,
          'max-active-non-employee-engagements-number': settings.maxActiveNonEmployeeEngagementsNumber.toString()
        }
      };
    }

    return feature;
  })
});
